import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './Button.styles';

const Button = ({ children, styles = [], ...props }) => (
  <Container $styles={styles} {...props}>
    {children}
  </Container>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  styles: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ),
};

export default Button;
